import { ApiFactory } from 'apiFactory'
import { dayjs } from 'Tools/dateUtils'
import { Campaignservicev1OrderLine } from 'next-gen-sdk'

const createEmptyPromise = (): Promise<undefined> => {
  return new Promise((resolve) => {
    return resolve(undefined)
  })
}

export const getOrderLineStats = async (
  orderLine: Campaignservicev1OrderLine,
  orgId: string,
  timeFrame?: string,
  timeZone?: string,
) => {
  const token = localStorage.getItem('eltoro_token')
  const { statsServiceAPI } = ApiFactory(token)

  if (!orgId || !orderLine.id) {
    return undefined
  }
  try {
    return statsServiceAPI?.advertisingPlatformServiceGetStats(orgId, {
      startTime: dayjs
        .tz(orderLine.startTime)
        .subtract(1, 'day') // get all imps regardless of timezone funniness.
        .startOf('day')
        .utc()
        .toDate(),
      endTime: dayjs
        .tz(orderLine.endTime)
        .add(1, 'day')
        .startOf('day')
        .toDate(),
      timezone:
        timeZone &&
        timeZone !== 'AST' &&
        timeZone !== 'ADT' &&
        timeZone !== 'AKST' &&
        timeZone !== 'AKDT'
          ? timeZone
          : 'UTC',
      timeFrame: timeFrame ? timeFrame : 'total',
      levelOfDetail: ['order_line_id'],
      orderLineId: [orderLine.id],
    })
  } catch (error) {
    console.log(`Error Fetching Stats for ${orderLine.id}`)
    return createEmptyPromise()
  }
}
